import store from "@/store";
const month = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
const monthUTC = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
dayjs.extend(utc);
dayjs.extend(timezone);

export function updateTime(time) {
    let time_zone = dayjs(time).tz(store.getters.timezone);
    let offsetDate = new Date(dayjs.utc(time_zone)) + "";
    let today = dayjs().tz(store.getters.timezone);
    today = new Date(dayjs.utc(today)) + "";
    let parsedToday = today.split(" ");
    let parsedTime = offsetDate.split(" ");
    let parsedTodayDate = parsedToday[1] + " " + parsedToday[2] + " " + parsedToday[3];
    let parsedTimeDate = parsedTime[1] + " " + parsedTime[2] + " " + parsedTime[3];
    let parsedYesterdayTime = parsedToday[2] - 1;
    parsedYesterdayTime = parsedYesterdayTime < 10 ? '0' + parsedYesterdayTime : parsedYesterdayTime;
    let parsedTimeDateYesterday = parsedToday[1] + " " + parsedYesterdayTime + " " + parsedToday[3];
    let parsedTomorrowTime = parsedToday[2] + 1;
    parsedTomorrowTime = parsedTomorrowTime < 10 ? '0' + parsedTomorrowTime : parsedTomorrowTime;
    let parsedTimeDateTomorrow = parsedToday[1] + " " + parsedTomorrowTime + " " + parsedToday[3];
    if (parsedTodayDate == parsedTimeDate) {
        return "сегодня в " + parsedTime[4].slice(0, 5);
    } else if (parsedTimeDateYesterday == parsedTimeDate) {
        return "вчера в " + parsedTime[4].slice(0, 5);
    } else if (parsedTimeDateTomorrow == parsedTimeDate) {
        return "завтра в " + parsedTime[4].slice(0, 5);
    }
    let dateStr = parsedTime[2] + "." + month[monthUTC.indexOf(parsedTime[1])] + "." + parsedTime[3];
    let timeStr = parsedTime[4].slice(0, 5);
    return dateStr + " в " + timeStr;
}

export function getTimeFromDate(time) {
    let parsedTime = time.split(" ");
    let timeStr = parsedTime[1].slice(0, 5);
    return "в " + timeStr;
}

export function timeWithTZ(time) {
    return dayjs(time).format() + "";
}

export function getWord(num, words) {
    if (num) {
        let num1 = Math.abs(num) % 100;
        let num2 = num1 % 10;
        if (num1 > 10 && num1 < 20) return words[2];
        if (num2 > 1 && num2 < 5) return words[1];
        if (num2 == 1) return words[0];
        return words[2];
    }
    return "";
}